import UIComponent from "sap/ui/core/UIComponent";
import models from "./model/models";
import Device from "sap/ui/Device";
import JSONModel from "sap/ui/model/json/JSONModel";
import { AuthService } from "./service/Auth.service";
import { ThemeSelector } from "./service/ThemeSelector.service";

/**
 * @namespace com.unitrade.crm
 */
export default class Component extends UIComponent {
  public static metadata = {
    manifest: "json",
    interfaces: ["sap.ui.core.IAsyncContentCreation"],
  };

  private contentDensityClass: string;

  public init(): void {
    // call the base component's init function
    super.init();

    // create the device model
    this.setModel(models.createDeviceModel(), "device");

    // set global model
    const globalModel = new JSONModel({
      title: "Unitrade CRM",
      isNavBackEnabled: true,
    });
    this.setModel(globalModel, "global");

    ThemeSelector.initTheme();

    // create the views based on the url/hash
    this.getRouter().initialize();

    $.ajaxPrefilter(function (options) {
      const token = localStorage.getItem("auth_token");

      const headers = options.headers || {};
      headers["Content-Type"] = "application/json";
      headers["Accept"] = "application/json";
      //headers["ngrok-skip-browser-warning"] = "23763";

      if (token && !options.url.includes("/user/token/") && !options.url.includes("/haus/list")) {
        headers["Authorization"] = `Bearer ${token}`;
      }
      options.headers = headers;
    });

    $.ajaxSetup({
      statusCode: {
        401: (jxhr, textStatus, errorThrown) => {
          localStorage.removeItem("auth_token");
          localStorage.removeItem("auth_expiry");
          localStorage.removeItem("auth_username");
          const router = this.getRouter();
          const currentHash = router.getHashChanger().getHash();
          const routeInfo = router.getRouteInfoByHash(currentHash);
          AuthService.redirectToLogin(router, routeInfo.name, routeInfo.arguments);
        },
      },
    });
  }

  /**
   * This method can be called to determine whether the sapUiSizeCompact or sapUiSizeCozy
   * design mode class should be set, which influences the size appearance of some controls.
   * @public
   * @returns css class, either 'sapUiSizeCompact' or 'sapUiSizeCozy' - or an empty string if no css class should be set
   */
  public getContentDensityClass(): string {
    if (this.contentDensityClass === undefined) {
      // check whether FLP has already set the content density class; do nothing in this case
      if (document.body.classList.contains("sapUiSizeCozy") || document.body.classList.contains("sapUiSizeCompact")) {
        this.contentDensityClass = "";
      } else if (!Device.support.touch) {
        // apply "compact" mode if touch is not supported
        this.contentDensityClass = "sapUiSizeCompact";
      } else {
        // "cozy" in case of touch support; default for most sap.m controls, but needed for desktop-first controls like sap.ui.table.Table
        this.contentDensityClass = "sapUiSizeCozy";
      }
    }
    return this.contentDensityClass;
  }
}
